import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { ContentLayout } from '../../_NEXT_components/ContentLayout';
import { Button, EButtonIntent } from '../../_NEXT_components/Button';
import { PhoneAuthForm } from '../../_NEXT_components/PhoneAuthForm';
import { trackChangeLoginFlowTo, trackPhoneAuthResumeButtonClick } from '../../utils/tracking';
import { RootContext } from '../RootContainer';
export function PhoneAuthFormContainer(_ref) {
  var isSubmitting = _ref.isSubmitting,
      phone = _ref.phone,
      hasAsyncPhoneError = _ref.hasAsyncPhoneError,
      isPhoneInvalid = _ref.isPhoneInvalid,
      phoneError = _ref.phoneError,
      changePhone = _ref.changePhone,
      onSubmit = _ref.onSubmit,
      resetToUsernameAuth = _ref.resetToUsernameAuth;

  // FORM
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      changed = _React$useState2[0],
      setChanged = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      touched = _React$useState4[0],
      setTouched = _React$useState4[1];

  var _React$useContext = React.useContext(RootContext),
      _React$useContext$aut = _React$useContext.autoFocusDisabled,
      autoFocusDisabled = _React$useContext$aut === void 0 ? false : _React$useContext$aut; // PHONE


  var phoneRef = React.useRef(null);
  var handleChangePhone = React.useCallback(function (e) {
    var value = e.currentTarget.value;
    var newValue = value.replace(/\s/gi, '');
    changePhone(newValue);
    setChanged(true);
  }, [changePhone]);
  var switchView = React.useCallback(function () {
    trackChangeLoginFlowTo('email');
    resetToUsernameAuth();
  }, [resetToUsernameAuth]);
  var handleSubmit = React.useCallback(function () {
    setTouched(true);
    trackPhoneAuthResumeButtonClick();

    if (isPhoneInvalid) {
      if (phoneRef.current) {
        phoneRef.current.focus();
      }

      return;
    }

    onSubmit();
    setChanged(false);
  }, [onSubmit, isPhoneInvalid]);
  return /*#__PURE__*/React.createElement(ContentLayout, null, /*#__PURE__*/React.createElement(PhoneAuthForm, {
    autoFocusDisabled: autoFocusDisabled,
    phoneRef: phoneRef,
    handleSubmit: handleSubmit,
    isSubmitting: isSubmitting,
    phone: phone,
    onPhoneChange: handleChangePhone,
    phoneError: !changed && phoneError || undefined,
    isPhoneInvalid: touched && (isPhoneInvalid || !changed && hasAsyncPhoneError)
  }), /*#__PURE__*/React.createElement(Button, {
    dataMark: "SwitchToEmailAuth",
    fill: true,
    intent: EButtonIntent.Secondary,
    onClick: switchView
  }, "\u0412\u043E\u0439\u0442\u0438 \u043F\u043E email \u0438\u043B\u0438 id"));
}